import type { ChangeHandler, FieldErrors } from "react-hook-form";
import { uniqid } from "../../tools/utils";
import { roleNames,RoleLevel, roles, type rolesList } from "../../types/Users";

interface RegisterOutput {
    onChange:ChangeHandler,
    onBlur: ChangeHandler,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ref:	React.Ref<any>,
    name:	string
}

interface SelectProps{
    name:string,
    label:string,
    registerOutput:RegisterOutput,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    errors:FieldErrors<any>,
    maxlevel:number
    rest?:Record<string,string|boolean|number>
}


export function RoleSelectorBootstrap({name, label,maxlevel, registerOutput, errors,rest}:SelectProps){
    const id=uniqid(name);    
    return (

        <div className={ "form-floating " +  (errors[name] ? " is-invalid":'')}>
            <select className={"form-select "+ (errors[name]? " is-invalid":'')} id={id}
                {...registerOutput} 
                {...rest} 
            >
                <option value="">-----</option>
                {Object.entries(roleNames).sort((a,b)=> RoleLevel[a[0] as rolesList] - RoleLevel[b[0] as rolesList])
                .filter(([key])=> (RoleLevel[key as rolesList]<maxlevel && key!=roles.Visitors))
                .map(([key, value])=> 
                    <option key={key} value={key}>{value}</option>
                )}
                {maxlevel==RoleLevel.UA?
                <option  value="UA">{roleNames.UA}</option>
                :null}
            </select>
            <label className="form-label" htmlFor={id}>{label}</label>
        </div>
           
    );
}